<template>
  <div class="header" :style="{ backgroundColor: headerBackground }">
    <el-row class="header-menu hidden-md-and-down" justify="center">
      <div class="header-menu-div">
        <img src="@/assets/yinghui_logo.png" class="header-menu-logo" @click="onHomeClick()">
        <img src="@/assets/yinghui_text.png" class="header-menu-logo-text margin-left-10 margin-top-5" @click="onHomeClick()">
        <span ref="menuHome" class="header-menu-text margin-left-30" @click="onMenuClick($event, AppConfig.route_home)">首页</span>
        <span ref="menuCredit" class="header-menu-text margin-left-30" @click="onMenuClick($event, AppConfig.route_cpCredit)">企业信用维护</span>
        <span ref="menuAbout" class="header-menu-text margin-left-30" @click="onMenuClick($event, AppConfig.route_about)">关于我们</span>
        <img src="@/assets/home/img_home_menu_phone.png" class="header-menu-img-phone margin-left-100" @click="onPhoneClick()">
        <span class="header-menu-text margin-left-10" @click="onPhoneClick()">13167540356</span>
        <span class="header-menu-button margin-left-30" @click="onQrCodeClick()">扫码联系</span>
      </div>
    </el-row>
    <el-row class="header-menu-phone hidden-md-and-up" justify="space-between">
      <div class="header-menu-div">
        <img src="@/assets/yinghui_logo.png" class="header-menu-logo margin-left-20" @click="onHomeClick()">
        <img src="@/assets/yinghui_text.png" class="header-menu-logo-text margin-left-10 margin-top-5" @click="onHomeClick()">
      </div>
      <div class="header-menu-div">
        <img :src="isShowMenuPhone ? require('@/assets/img_phone_close.png') : require('@/assets/img_phone_menu.png')"
             class="header-menu-phone-img margin-right-20" @click="visiblePhoneMenu()">
      </div>
    </el-row>
  </div>
</template>

<script lang="ts" setup>
import {ref, onMounted, onBeforeUnmount} from 'vue';
import router from "@/router";
import {AppConfig} from "@/config";
import {isShowMenuPhone, isShowQrCodeDialog} from "@/views/data/CommonData";

const menuHome = ref(null);
const menuCredit = ref(null);
const menuAbout = ref(null);

const headerBackground = ref('rgba(255, 255, 255, 0.5)');
const handleScroll = () => {
  const scrollPosition = window.scrollY;
  const headerOpacity = Math.max(scrollPosition / 100, 0.5); // 最小透明度为0.5
  headerBackground.value = `rgba(255, 255, 255, ${headerOpacity})`;
};
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});
onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});

const clearMenuSelection = () => {
  menuHome.value.style.color = '#2f2f2f'
  menuCredit.value.style.color = '#2f2f2f'
  menuAbout.value.style.color = '#2f2f2f'
};

const onHomeClick = () => {
  router.push("/")
  clearMenuSelection()
  menuHome.value.style.color = '#1b57ec'
  isShowMenuPhone.value = false
}

const onMenuClick = (event, route: string) => {
  clearMenuSelection()
  event.target.style.color = '#1b57ec'
  router.push(route)
}

const visiblePhoneMenu = () => {
  isShowMenuPhone.value = !isShowMenuPhone.value; // 切换 boolean 变量的值
}

const onQrCodeClick = () =>{
  isShowQrCodeDialog.value = true
}

const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 1000;
  transition: background-color 0.5s;
}

.header-menu {
  height: 100%;
}

.header-menu-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-menu-logo {
  width: 25px;
  height: auto;
  cursor: pointer;
}
.header-menu-logo-text{
  width: 80px;
  height: auto;
  cursor: pointer;
}

.header-menu-img-phone {
  width: 30px;
  height: auto;
  cursor: pointer;
}

.header-menu-text {
  font-size: 14px;
  color: #2f2f2f;
  letter-spacing: 1px;
  cursor: pointer;
}

.header-menu-button {
  background-image: linear-gradient(to right, #1b57ec, #9775fa);
  height: 36px;
  width: 100px;
  border-radius: 18px;
  color: #f2f2f2;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
}

.header-menu-phone {
  height: 100%;
}

.header-menu-phone-img {
  width: 25px;
  height: auto;
}
</style>
